import { Link } from 'react-router-dom';
import { CheckCircle, Ticket, ArrowRight } from 'lucide-react';
import Seo from '../components/Seo';

const CheckoutSuccessPage = () => {
  return (
    <div 
      className="min-h-screen bg-[#050505] flex items-center justify-center px-4 pt-20"
      data-testid="checkout-success-page"
    >
      <Seo title="Payment Successful" description="Your Unight ticket purchase is confirmed. Check your email for your QR code." path="/checkout/success" noindex />
      <div className="max-w-md w-full text-center">
        <div className="animate-fade-in-up">
          <div className="w-20 h-20 rounded-full bg-[#B5FF00]/10 flex items-center justify-center mx-auto mb-6">
            <CheckCircle size={48} className="text-[#B5FF00]" />
          </div>
          <h1 className="font-['Josefin_Sans'] text-5xl md:text-6xl font-bold text-white mb-2">
            PAYMENT SUCCESSFUL
          </h1>
          <p className="text-zinc-400 mb-8">
            Your tickets have been confirmed. Get ready for an unforgettable night.
          </p>

          <div className="flex flex-col gap-4">
            <Link 
              to="/my-tickets" 
              className="btn-primary flex items-center justify-center gap-2"
              data-testid="view-tickets-btn"
            >
              <Ticket size={18} />
              VIEW MY TICKETS
            </Link>
            <Link 
              to="/events" 
              className="btn-secondary flex items-center justify-center gap-2"
            >
              BROWSE MORE EVENTS
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;
